/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.StationsTemplatesPreview;

export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const dataSelector = createSelector(rootSelector, (state) => state.data);
export const errorSelector = createSelector(rootSelector, (state) => state.error);

export const stationsTemplatesSelector = createSelector(dataSelector, (data) => data?.stationsTemplates);

export default {
  dataSelector,
  statusSelector,
  errorSelector,
  stationsTemplatesSelector,
};
